export var IdentityProviderBinding;
(function (IdentityProviderBinding) {
    IdentityProviderBinding["Redirect"] = "redirect";
    IdentityProviderBinding["Post"] = "post";
})(IdentityProviderBinding || (IdentityProviderBinding = {}));
//# sourceMappingURL=identity-provider-binding.js.map